import { SettingsLayout, type SettingsNavSection } from '@/components/settings/SettingsLayout.tsx';

/**
 * Everything Witina tells you, and everything that decides what it tells you.
 *
 * Top-level rather than a corner of account settings because the inbox is a daily
 * read, not a preference — the bell in the top bar has always been a shortcut into a
 * page that did not exist.
 *
 * **Inbox and delivery log are not the same list, and the nav must not imply they
 * are.** The inbox is what reached you in-app; the delivery log is every decision the
 * router made about you on every channel, including the ones it declined to send.
 * "Why didn't I get emailed?" is only answerable in the second.
 *
 * The organization's routing, shared destinations and PSA ticketing are a group under
 * Organization Admin, with the rest of what configures the organization.
 */
const NotificationsLayout = () => {
  const sections: SettingsNavSection[] = [
    {
      label: 'Notifications',
      visible: true,
      items: [
        { to: '/notifications', label: 'Inbox' },
        { to: '/notifications/rules', label: 'Rules' },
        { to: '/notifications/destinations', label: 'Destinations' },
        { to: '/notifications/deliveries', label: 'Delivery log' },
      ],
    },
  ];

  return <SettingsLayout sections={sections} ariaLabel="Notification sections" />;
};

export default NotificationsLayout;
